import type { PlanningOptions } from '../types';
export const defaultPlanningOptions: PlanningOptions = { prefer_regular_players: true, max_one_stand_in: true, historical_participation: true, priority: 'continuity' };

/** Match-specific stand-ins, never ordinary reserves. Includes every quarter/slot. */
export function assertStandInLimit(schedule: Record<string, unknown>, standins: string[], enabled = true): void {
  if (!enabled) return;
  const ids = new Set(standins);
  const moments = new Map<string, Set<string>>();
  for (const [key, value] of Object.entries(schedule)) {
    const cell = key.match(/^(.+)-(\d+)-(\d+)$/);
    if (!cell || cell[1].startsWith('reserve')) continue;
    const id = typeof value === 'string' ? value : value && typeof value === 'object' && 'id' in value ? String(value.id) : '';
    if (!ids.has(id)) continue;
    const moment = `${cell[2]}-${cell[3]}`;
    const players = moments.get(moment) ?? new Set<string>();
    players.add(id);
    moments.set(moment, players);
    if (players.size > 1) throw new Error('Maximaal één invaller tegelijk in het veld. / At most one stand-in may play at a time.');
  }
}
